import { render, staticRenderFns } from "./ConvenienceFeeOverview.vue?vue&type=template&id=56071250&scoped=true"
import script from "./ConvenienceFeeOverview.vue?vue&type=script&lang=js"
export * from "./ConvenienceFeeOverview.vue?vue&type=script&lang=js"
import style0 from "./ConvenienceFeeOverview.vue?vue&type=style&index=0&id=56071250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56071250",
  null
  
)

export default component.exports